import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';

@Injectable()
export class HubLevelService {
  constructor(private http: HttpClient, private headers: HttpHeadersService) {}
  getHubData(request: any) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getHubData;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders('v2_api'));
  }

  getExportData(request: any) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getExportData;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }
  getProductList() {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getProduct;
    return this.http.get(url, this.headers.getCommonHttpHeaders('v2_api'));
  }
  getAllCurbiCountries() {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getCurbiCountries;
    return this.http.get(url, this.headers.getCommonHttpHeaders('v2_api'));
  }
  getHubPartnerCountryListByCountryPartner(request) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getHubPartnerCountryListByCountryPartner;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders('v2_api')).pipe(
      map((response: any) => {
        const updatedResponse = { ...response };
        let newData = [];
        updatedResponse.result.responseData.forEach((item) => {
          if (item.orgName != null) {
            newData.push({ partnercode: item.partnerCode, orgname: item.orgName, countryname: item.countryName });
          }
        });
        updatedResponse.result.responseData = newData;
        return updatedResponse;
      })
    );
  }
  getCountrylistByPartnerAndDirection(request: any) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getCountrylistByPartnerAndDirection;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders('v2_api'));
  }
  getAllDirectionByPartner(partnerCode: string) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getAllDirectionByPartner + partnerCode;
    return this.http.post(url, {}, this.headers.getCommonHttpHeaders('v2_api'));
  }
  getHubPartnerCountryListByDiretion(request) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getHubPartnerCountryListByDiretion;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders('v2_api')).pipe(
      map((response: any) => {
        const updatedResponse = { ...response };
        let newData = [];
        updatedResponse.result.responseData.forEach((item) => {
          if ('partnerCode' in item) {
            newData.push({ partnercode: item.partnerCode, orgname: item.orgName, countryname: item.countryName });
          } else {
            newData.push(item);
          }
        });
        updatedResponse.result.responseData = newData;
        return updatedResponse;
      })
    );
  }
  getPartnerListByCountry(request: any) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.HUBLEVEL.getPartnerListByCountry;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders('v2_api'));
  }
}
